export default "__VITE_PUBLIC_ASSET__5f22e57c__"